import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shell padding20px" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "height20px" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_set_access = _resolveComponent("set-access")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_set_access, {
        id: _ctx.roomId,
        pid: _ctx.pid,
        type: "self",
        commit: _ctx.commit,
        initForm: _ctx.initSelf,
        onGetForm: _ctx.submit
      }, null, 8, ["id", "pid", "commit", "initForm", "onGetForm"])
    ]),
    _hoisted_2,
    _createVNode(_component_cus_button, {
      type: "blue",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.commit++))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
      ]),
      _: 1
    })
  ]))
}